module.exports = __webpack_public_path__ + "static/media/uber-eats.d803a25a.png";